var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { useTranslation } from '../../../abstractions/hooks/useTranslation';
import withDesign from '../../../hocs/withDesign';
import { StyledBaseInput } from './styled';
export var BaseInputComponent = forwardRef(function (_a, ref) {
    var _b = _a.placeholder, _c = _b === void 0 ? { i18n: {} } : _b, i18n = _c.i18n, props = __rest(_a, ["placeholder"]);
    var translate = useTranslation().translate;
    var placeholder = translate(i18n);
    var type = props.type;
    var extraProps = {};
    if (type === 'number') {
        extraProps.onWheel = function (e) {
            e.target.blur();
        };
    }
    return _jsx(StyledBaseInput, __assign({ ref: ref, placeholder: placeholder }, props, extraProps));
});
export var BaseInput = withDesign(BaseInputComponent);
BaseInput.displayName = 'BaseInput';
export * from './BaseInput.types';
